import { Spin } from "antd"
import { CSSProperties } from "react"
import Masonry from "react-masonry-css"

import ComponentErrorBoundary from "#blocks/ComponentErrorBoundary"
import Flex from "#blocks/Flex"
import { SFormHeader } from "#blocks/Form/formComponents"
import { Uuid } from "#customTypes/globalTypes"

import TeacherAttendanceListClass from "./TeacherAttendanceListClass"
import useTeacherAttendanceData from "./useTeacherAttendanceData"

const style: CSSProperties = {
  display: "flex",
  gap: 30,
}

const TeacherAttendanceList = ({ userId }: { userId: Uuid }) => {
  const { user, sortedTeacherAttendance, isFulfilled } =
    useTeacherAttendanceData(userId)

  if (!user) return null

  const MAX_HEIGHT = 700

  return (
    <Flex col gap={30} style={{ marginBottom: 30, height: MAX_HEIGHT + 100 }}>
      <Flex col style={{ height: "100%" }}>
        <SFormHeader>Teacher Attendance</SFormHeader>

        <Flex style={{ height: "100%", overflowY: "auto" }}>
          {!isFulfilled ? (
            <Spin />
          ) : isFulfilled && sortedTeacherAttendance.length === 0 ? (
            <p>No attendance data found</p>
          ) : (
            <Masonry
              breakpointCols={2}
              className="masonry-grid"
              columnClassName="masonry-grid_column"
              style={style}
            >
              {sortedTeacherAttendance.map((classAttendance) => (
                <ComponentErrorBoundary
                  key={`teacher-attendance-${classAttendance.classId}`}
                  context={`Class: ${classAttendance.name}`}
                  fallbackStyle={{
                    width: 200,
                    minHeight: 80,
                    marginBottom: 10,
                  }}
                >
                  <TeacherAttendanceListClass
                    classAttendance={classAttendance}
                    user={user}
                  />
                </ComponentErrorBoundary>
              ))}
            </Masonry>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default TeacherAttendanceList
